// extracted by mini-css-extract-plugin
module.exports = {"c-label":"invitationMail_c-label__j8YfC","c-textarea-input":"invitationMail_c-textarea-input__gK2CJ","c-button":"invitationMail_c-button__1L8rP"};